import * as React from 'react';
import {
    OutlinedInput,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    Checkbox,
    TextField,
    Box,
    Typography,
    Tooltip,
    Avatar,
    Chip,
    Button,
    Stack,
    ListSubheader
} from '@mui/material';
import { CloseBlackIcon } from '../../icons';

import { KeyboardArrowDown } from '@mui/icons-material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 300,
        },
    },
    disableAutoFocusItem: true,
};

const getInitials = (fullName) => {
    const parts = fullName.trim().split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

function TruncatedTooltip({ children }) {
    const textRef = React.useRef(null);
    const [isTruncated, setIsTruncated] = React.useState(false);

    React.useEffect(() => {
        const el = textRef.current;
        if (el) {
            setIsTruncated(el.scrollWidth > el.clientWidth);
        }
    }, [children]);

    return isTruncated ? (
        <Tooltip title={children}>
            <Typography
                ref={textRef}
                noWrap
                sx={{
                    maxWidth: '160px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: '14px',
                    color: '#111',
                    cursor: 'default',
                }}
            >
                {children}
            </Typography>
        </Tooltip>
    ) : (
        <Typography
            ref={textRef}
            noWrap
            sx={{
                maxWidth: '160px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: '14px',
                color: '#111',
            }}
        >
            {children}
        </Typography>
    );
}

export default function MultiClientSelect({
    label = 'Select Users',
    options = [],
    selectedValues = [],
    onChange = () => { },
}) {
    const [searchTerm, setSearchTerm] = React.useState('');

    const handleChange = (event) => {
        onChange(event.target.value);
    };

    const handleDelete = (valueToDelete) => {
        onChange(selectedValues.filter((value) => value !== valueToDelete));
    };

    const handleRemoveAll = () => {
        onChange([]);
    };

    const filteredOptions = options.filter((opt) =>
        opt.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Box>
            {/* Select Component */}
            <FormControl sx={{ width: '100%', mb: 2  , }}>
                <Select
                    id={`${label}-select`}
                    multiple
                    value={selectedValues}
                    IconComponent={KeyboardArrowDown}
                    onChange={handleChange}
                    displayEmpty
                    
                    // input={
                    //     <OutlinedInput
                    //         sx={{
                    //             height: 40,
                    //             borderRadius: '6px',
                    //             paddingRight: '32px',
                    //             display: 'flex',
                    //             alignItems: 'center',
                    //             fontFamily:'Manrope',
                    //             fontSize:'14px',
                    //         }}
                    //     />
                    // }
                    renderValue={(selected) =>
                        selected.length > 0 ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontFamily:'Manrope',
                                    fontSize:'14px'
                                }}
                            >
                                {selected.map((value) => {
                                    const selectedOption = options.find((opt) => opt.name === value);
                                    return (
                                        <Chip
                                            key={value}
                                            label={selectedOption?.name || value}
                                            size="small"
                                            sx={{
                                                height: 24,
                                                '& .MuiChip-label': {
                                                    fontSize: '0.75rem',
                                                    fontFamily:'Manrope'
                                                },
                                            }}
                                        />
                                    );
                                })}
                            </Box>
                        ) : (
                            <Typography sx={{ color: '#A0AEC0', fontFamily:'Manrope', fontSize:'14px' }}>{label}</Typography>
                        )
                    }
                    MenuProps={MenuProps}
                    sx={{
                        background: '#fff',
                        borderRadius: '6px',
                        '& .MuiSelect-select': {
                            paddingTop: '8px',
                            paddingBottom: '7px',
                            height: 23,
                            fontSize: '12px',
                            fontFamily:'Manrope'
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderRadius: '6px',
                            fontFamily:'Manrope'
                        },
                        '& .MuiSelect-icon': {
                            color: '#64748B',
                            right: '8px',
                            fontFamily:'Manrope'
                        },
                    }}
                >
                    <ListSubheader
                        disableRipple
                        disableTouchRipple
                        sx={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 999,
                            background: '#fff !important',
                            fontFamily:'Manrope'
                        }}
                    >
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyDown={(e) => {
                                e.stopPropagation()
                            }}
                            onMouseDown={(e) => {
                                e.stopPropagation()
                            }}
                        />
                    </ListSubheader>

                    {filteredOptions.map((opt) => (
                        <MenuItem key={opt.name} value={opt.name}>
                            <Checkbox
                                checked={selectedValues.includes(opt.name)}
                                icon={
                                    <Box
                                        sx={{
                                            width: 24,
                                            height: 24,
                                            borderRadius: '4px',
                                            border: '1px solid #D0D5DD',
                                            backgroundColor: '#E5E8EB',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontFamily:'Manrope'
                                        }}
                                    >
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                            <defs>
                                                <filter
                                                    id="shadow"
                                                    x="-50%"
                                                    y="-50%"
                                                    width="200%"
                                                    height="200%"
                                                >
                                                    <feDropShadow
                                                        dx="0"
                                                        dy="1"
                                                        stdDeviation="1"
                                                        floodColor="black"
                                                        floodOpacity="0.4"
                                                    />
                                                </filter>
                                            </defs>
                                            <path
                                                d="M20 6L9 17L4 12"
                                                stroke="white"
                                                strokeWidth="3"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                filter="url(#shadow)"
                                            />
                                        </svg>
                                    </Box>
                                }
                                checkedIcon={
                                    <Box
                                        sx={{
                                            width: 24,
                                            height: 24,
                                            borderRadius: '4px',
                                            backgroundColor: '#1976d2',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontFamily:'Manrope'
                                        }}
                                    >
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                            <path
                                                d="M20 6L9 17L4 12"
                                                stroke="white"
                                                strokeWidth="3"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </Box>
                                }
                            />
                            {opt.image ? (
                                <Avatar
                                    src={opt.image}
                                    alt={opt.name}
                                    sx={{ width: 30, height: 30, mr: 1, fontFamily:'Manrope', color:'#fff' }}
                                />
                            ) : (
                                <Avatar
                                    sx={{
                                        width: 30,
                                        height: 30,
                                        backgroundColor: '#1976d2',
                                        fontSize: 12,
                                        fontWeight: 600,
                                        mr: 1,
                                        fontFamily:'Manrope',
                                        color:'#fff'
                                    }}
                                >
                                    {getInitials(opt.name)}
                                </Avatar>
                            )}
                            <TruncatedTooltip sx={{fontFamily:'Manrope'}}>{opt.name}</TruncatedTooltip>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>




            {/* Summary Box with Remove All button */}
            {selectedValues.length > 0 && (
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 1,
                    p: '0',
                    backgroundColor: '#fff',
                    borderRadius: 1,
                    fontFamily:'Manrope'
                }}>
                    <Typography variant="body2" sx={{fontFamily:'Manrope'}}>
                        {selectedValues.length} {selectedValues.length === 1 ? 'member' : 'members'} selected
                    </Typography>
                    <Button
                        size="small"
                        onClick={handleRemoveAll}
                        sx={{ color: '#0076FE', fontFamily:'Manrope' }}
                    >
                        Remove All
                    </Button>
                </Box>
            )}
            {/* Selected Chips outside the select */}
            <Stack direction="row" spacing={1} sx={{flexWrap: 'wrap', gap: 0, '& .MuiButtonBase-root': {margin: 0, marginBottom:'6px', marginRight:'6px' ,backgroundColor:'#fff', border:'1px solid #DFDFDF', height:'34px', fontFamily:'Manrope'} }}>
                {selectedValues.map((value) => {
                    const selectedOption = options.find((opt) => opt.name === value);
                    return (
                        <Chip
                            key={value}
                            label={selectedOption?.name || value}
                            onDelete={() => handleDelete(value)}
                            deleteIcon={<CloseBlackIcon />}
                            avatar={
                                selectedOption?.image ? (
                                    <Avatar src={selectedOption.image} alt={selectedOption.name} />
                                ) : (
                                    <Avatar sx={{ bgcolor: '#1976d2', fontSize: 12, fontFamily:'Manrope'}}>
                                        {selectedOption ? getInitials(selectedOption.name) : '?'}
                                    </Avatar>
                                )
                            }
                            sx={{
                                height: 32,
                                '& .MuiChip-avatar': {
                                    width: 22,
                                    height: 22,
                                    color:'#fff',
                                    
                                },
                            }}
                        />
                    );
                })}
            </Stack>
        </Box>
    );
}